import React from "react";
import {
  IHighlightCommon,
  PopoverOptionNotes,
} from "~/typings/annotate/annotation";
import { Trans } from "@lingui/react/macro";

export default function AnnotateNote({
  highlight,
  config,
  closePopover,
}: {
  config: PopoverOptionNotes;
  highlight: IHighlightCommon;
  closePopover: () => void;
}) {
  const handleNote = () => {
    config.noteClicked({
      ...highlight,
      canEdit: true,
      color: highlight.color,
    });

    closePopover();
  };

  return (
    <button
      onClick={handleNote}
      className="flex text-sm sm:text-base justify-center h-10 px-2 items-center sm:px-4 cursor-pointer space-x-1"
    >
      <Trans>Note</Trans>
    </button>
  );
}
